<template>
	<div>
	  <el-form ref="form" label-width="80px">
		<el-form-item label="角色名稱">
		  <el-input v-model="name" placeholder="請輸入角色名稱" class="w-50"></el-input>
		</el-form-item>
  
		<el-form-item label="权限分配">
		  <el-tabs v-model="activeName">
			<el-tab-pane v-for="top in permissions" :key="top.id" :label="top.name" :name="top.name">
			  <permission-item
				:permission="top"
				@update:select="handleSelect"
			  ></permission-item>
			</el-tab-pane>
		  </el-tabs>
		</el-form-item>
	  </el-form>
	  <el-button @click="submit">保存</el-button>
	</div>
  </template>
  
  <script>
  import PermissionItem from './PermissionItem.vue';
  export default {
	components: {
	  PermissionItem
	},
	inject: ['layout'],
	data() {
	  return {
		id: 0,
		name: "",
		permissions: [],
		activeName: '',
	  };
	},
	created() {
	  this.getParams();
	},
	methods: {
	  getParams() {
		let data = this.$route.query;
		if (data.item) {
		  this.id = data.item.id;
		  this.name = data.item.name;
		}
		this.__init();
	  },
	  toBack() {
		this.$router.go(-1);
	  },
	  submit() {
		
  
		// Collecting selected permissions
		const selectedPermissions = this.collectSelectedPermissions(this.permissions);
		console.log(selectedPermissions)
		if (this.name == '') {
		  this.$notify.error({
			title: '错误',
			message: '角色名稱不能为空'
		  });
		  return;
		}
		this.axios.post('/admin/user/addRule', {
		  name: this.name,
		  id: this.id,
		  rule: selectedPermissions
		}, {
		  token: true,
		  loading: true
		}).then(res => {
		  let list = res.data;
			
		  if (list.code == 1) {
			this.$message.success(list.msg);
			this.$router.go(-1);
		  } else {
			this.$message.error(list.msg);
		  }
		});
	  },
	  collectSelectedPermissions(permissions) {
		return permissions.flatMap(permission => {
		  const selected = permission.checkAll || permission.isIndeterminate;
		  const childSelections = this.collectSelectedPermissions(permission.children || []);
		  return selected ? [permission.id, ...childSelections] : childSelections;
		});
	  },
	  __init() {
		this.layout.loading = true;
		this.axios.post('/admin/user/rulePage', {
		  id: this.id
		}, {
		  token: true,
		  loading: true
		}).then(res => {
		  let list = res.data;
		 
		  this.activeName = list.data.list[0].name;
		  this.permissions = list.data.list;
  
		  // Ensure each permission has a parent reference
		  this.permissions.forEach(permission => {
			this.addParentReference(permission, null);
			this.setDefaultSelection(permission);
		  });
  
		  this.layout.loading = false;
		}).catch(err => {
		  console.log(err);
		  this.layout.loading = false;
		});
	  },
	  addParentReference(permission, parent) {
		this.$set(permission, 'parent', parent);
		if (permission.children) {
		  permission.children.forEach(child => {
			this.addParentReference(child, permission);
		  });
		}
	  },
	  handleSelect({ permission, value }) {
		this.updatePermissionSelection(permission, value);
	  },
	  setDefaultSelection(permission) {
    if (permission.is_sel) {
        permission.checkAll = true;
    }
    if (permission.children) {
        permission.children.forEach(child => {
            this.setDefaultSelection(child);
        });
    }
},
	  updatePermissionSelection(permission, value) {
		// 递归更新权限選擇狀態
		permission.checkAll = value;
		if (permission.children) {
		  permission.children.forEach(child => {
			this.updatePermissionSelection(child, value);
		  });
		}
	  }
	}
  };
  </script>
  